// extracted by mini-css-extract-plugin
export var pageContainer = "_r-1";
export var settingsContent = "_r-0";